import { EventCDR } from "callable-data-objects";
import { useEventGroup } from "Hooks/Endpoints";
import React, { useEffect } from "react";
import { Table, Segment, Checkbox, Header } from "semantic-ui-react";
import NumberFormat from "react-number-format";
import moment from "moment";
import useCheckRole from "Hooks/APICheckRole";

const EventCDRView = () => {
  const { hasRole, roles } = useCheckRole();
  const { getCDR, cdrs, event } = useEventGroup();

  useEffect(() => {
    if (event) getCDR();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);
  return (
    <Segment color='purple'>
      <Header as='h4'>Session Detail Records</Header>
      <Table stackable celled compact size='small'>
        <Table.Header>
          <Table.Row>
            <Table.Cell>Date</Table.Cell>
            <Table.Cell>From</Table.Cell>
            <Table.Cell>To</Table.Cell>
            <Table.Cell>Product</Table.Cell>
            <Table.Cell>Billable</Table.Cell>
            <Table.Cell>Qty</Table.Cell>
            {hasRole(roles.account.events.cdr.roles.cost) && (
              <Table.Cell>Unit</Table.Cell>
            )}
            {hasRole(roles.account.events.cdr.roles.cost) && (
              <Table.Cell>Total</Table.Cell>
            )}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {cdrs.map((cdr: EventCDR, index: number) => (
            <Table.Row key={`cdr-${index}`}>
              <Table.Cell>{moment(cdr.created).format("YYYY-MM-DD HH:mm:ss")}</Table.Cell>
              <Table.Cell>{cdr.from}</Table.Cell>
              <Table.Cell>{cdr.to}</Table.Cell>
              <Table.Cell>{cdr.service}</Table.Cell>
              <Table.Cell>
                <Checkbox toggle checked={cdr.billable} />
              </Table.Cell>
              <Table.Cell>
                <NumberFormat
                  value={cdr.qty}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalScale={6}
                />
              </Table.Cell>
              {hasRole(roles.account.events.cdr.roles.cost) && (
                <Table.Cell>
                  <NumberFormat
                    value={cdr.unitPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={6}
                  />
                </Table.Cell>
              )}
              {hasRole(roles.account.events.cdr.roles.cost) && (
                <Table.Cell>
                  <NumberFormat
                    value={cdr.total}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={6}
                  />
                </Table.Cell>
              )}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default EventCDRView;
